<ion-header class="display-screen-header">
  
  <ion-label class="clock">
    {{ orders?.length ? (orders.length + ' Active Orders') : 'No Active Orders' }}
  </ion-label>

  <ion-title>👨‍🍳 Live Kitchen Orders</ion-title>

  <div class="branch-selector">
      <ion-select
        placeholder="Select a branch"
        [(ngModel)]="branchId"
        (ionChange)="onBranchChange($event)"
        class="branch-dropdown"
      >
        <ion-select-option *ngFor="let b of branches" [value]="b.restaurantBranchId">
          {{ b?.name }}
        </ion-select-option>
      </ion-select>
  </div>

  <ion-button class="back-btn" (click)="onBackClick()">
    <ion-icon name="arrow-back-outline"></ion-icon>
    Back
  </ion-button>

</ion-header>

<ion-content class="display-screen-root">

  <ion-grid class="orders-grid">
    <ion-row>
      <ion-col size="12" *ngFor="let order of sortedOrders(); let i = index">
        <div class="order-card">
          <div class="card-content">
  
            <!-- LEFT SIDE -->
            <div class="card-left">
              <div class="order-number">#{{ order?.orderNumber }}</div>
              <div class="restaurant">
                {{ order?.restaurantModel?.name || order?.restaurantBranchModel?.name || '—' }}
              </div>
              <div class="status-meta justify-content-start">
                <span>{{ order?.orderType | removeUnderScoreAndCaptitalize }}</span>
                <span class="dot">•</span>
                <span>{{ order?.table || order?.restaurantBranchModel?.name || '' }}</span>
              </div>
            </div>
  
            <!-- MIDDLE SECTION -->
            <div class="card-middle">
              <div class="status-badge" [ngClass]="statusClass(order?.orderStatus)">{{ order?.orderStatus | removeUnderScoreAndCaptitalize }}</div>
              <div class="status-meta justify-content-center">
                <span>{{ order?.orderPaymentStatus | removeUnderScoreAndCaptitalize }}</span>
                <span class="dot">•</span>
                <span>{{ timeSince(order?.createdAt) }}</span>
                <span class="dot">•</span>
                <span>{{ maskedCustomer(order?.customerName) }}</span>
              </div>
            </div>
  
            <!-- RIGHT SIDE -->
            <div class="card-right">
              <div class="amount">{{ formatCurrency(order?.orderPriceModel?.totalPriceWithDiscountAndTax) }}</div>
              <div class="progress-bar" [ngClass]="progressColorClass(order?.orderStatus)">
                <div class="progress" [style.width.%]="statusProgress(order?.orderStatus)"></div>
              </div>
            </div>
  
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  
  <ion-footer class="display-screen-footer"> Please wait — your order status will be updated here
  </ion-footer>

</ion-content>
